<div id="popup-modal" tabindex="-1" class="overflow-y-auto overflow-x-hidden top-0 right-0 left-0 z-50 md:inset-0 h-modal md:h-full">
  <div class="relative w-[370px] lg:w-[590px] h-full md:h-auto">
    <div class="relative bg-neutral-06 rounded-lg shadow dark:bg-gray-700">
      <div
        (click)="onClose()"
        class="absolute z-50 cursor-pointer top-1 right-4 lg:top-4 focus:boder-0 lg:right-4 text-gray-400 bg-transparent hover:bg-gray-200
          hover:text-gray-900 rounded-lg text-sm p-2 ml-auto inline-flex items-center"
        data-modal-toggle="popup-modal"
      >
        <svg
          class="text-neutral-06 stroke-white hidden lg:block"
          width="32"
          stroke="currentColor"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M27.0635 5.49365L5.23599 28.4268" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
          <path d="M27.0635 28.4269L5.23599 5.49369" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        <svg class="block z-50 lg:hidden" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M27.0635 5.49365L5.23599 28.4268" stroke="#fff" stroke-width="1.5" stroke-linecap="round" />
          <path d="M27.0635 28.4269L5.23599 5.49369" stroke="#fff" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        <span class="sr-only">Close modal</span>
      </div>

      <div class="">
        <div class="relative bg-neutral-06">
          <p class="text-xl md:text-4xl text-primary font-bold text-center pt-16">
            {{ 'SUCCESSFUL_MESSAGE' | translate }}
          </p>
          <hr class="border-black my-5 mx-[30px]" />
          <div class="flex justify-center">
            <svg class="mt-3" width="116" height="121" viewBox="0 0 116 121" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M57.3047 105.037C78.0154 105.037 94.8047 88.2478 94.8047 67.5371C94.8047 46.8264 78.0154 30.0371 57.3047 30.0371C36.594 30.0371 19.8047 46.8264 19.8047 67.5371C19.8047 88.2478 36.594 105.037 57.3047 105.037Z"
                stroke="#01A54E"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M42 69.4524L53.3369 80L75 55" stroke="#01A54E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M57.5 114C83.1812 114 104 93.1812 104 67.5C104 41.8188 83.1812 21 57.5 21C31.8188 21 11 41.8188 11 67.5C11 93.1812 31.8188 114 57.5 114Z"
                stroke="#01A54E"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-dasharray="8 8"
              />
              <path
                d="M108.5 33C110.433 33 112 31.433 112 29.5C112 27.567 110.433 26 108.5 26C106.567 26 105 27.567 105 29.5C105 31.433 106.567 33 108.5 33Z"
                stroke="#DBAB27"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 119C8.20914 119 10 117.209 10 115C10 112.791 8.20914 111 6 111C3.79086 111 2 112.791 2 115C2 117.209 3.79086 119 6 119Z"
                stroke="#DBAB27"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M17 7L7 7" stroke="#DBAB27" stroke-width="2.5" stroke-linecap="round" />
              <path d="M12 12L12 2" stroke="#DBAB27" stroke-width="2.5" stroke-linecap="round" />
              <path d="M114 113H104" stroke="#01A54E" stroke-width="2.5" stroke-linecap="round" />
              <path d="M109 118L109 108" stroke="#01A54E" stroke-width="2.5" stroke-linecap="round" />
              <path d="M12 98.5H7" stroke="#01A54E" stroke-width="2.5" stroke-linecap="round" />
              <path d="M9.5 101L9.5 96" stroke="#01A54E" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>

          <p class="text-sm md:text-base text-neutral-01 mt-8 text-center">
            {{ 'REGISTER_SUCCESSFUL_CONTENT' | translate }}
          </p>

          <div class="mt-5 pb-12 flex justify-center">
            <button class="bg-primary color-white font-medium flex items-center py-3 px-8" (click)="onClose()">
              {{ 'OK' | translate }}
              <img class="ml-3" src="/assets/svg/ic-arrow-right.svg" alt="ic-arrow-right" loading="lazy" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
